<template>
  <Session>
    <LayoutDefault>
      <template #content>
        <slot />
      </template>
    </LayoutDefault>
  </Session>
</template>
